import React, { createContext, useState } from "react";
import { ContextProviderProps } from "../../types";
import {
  TrackAndTraceState,
  UpdateTrackAndTraceFunction,
} from "./trackAndTrace.types";

export const initialState = (): TrackAndTraceState => {
  return {
    //Response for inicijalnaTabelaZaPracenje

    pracenjeTabela: [],

    //Response for inicijalniPodaciZaPracenje

    tipPakovanja: [],
    statusFilter: [],
  };
};

interface ITrackAndTraceContext {
  trackAndTrace: TrackAndTraceState;
  setTrackAndTrace: UpdateTrackAndTraceFunction;
  clearTrackAndTraceState: () => void;
}

export const TrackAndTraceContext = createContext<ITrackAndTraceContext>(
  null as any
);

export const TrackAndTraceContextProvider = ({
  children,
}: ContextProviderProps) => {
  const [trackAndTrace, setTrackAndTraceState] = useState(initialState());

  const handleSetTrackAndTrace = (
    updatedState: Partial<TrackAndTraceState>
  ) => {
    setTrackAndTraceState((prev) => ({ ...prev, ...updatedState }));
  };

  const setTrackAndTrace = (updatedState: Partial<TrackAndTraceState>) => {
    handleSetTrackAndTrace({ ...updatedState });
  };

  const clearTrackAndTraceState = () => {
    setTrackAndTraceState(initialState());
  };

  return (
    <TrackAndTraceContext.Provider
      value={{
        trackAndTrace,
        setTrackAndTrace,
        clearTrackAndTraceState,
      }}
    >
      {children}
    </TrackAndTraceContext.Provider>
  );
};
